"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actualizeDrawAreaFrame = exports.reorganize_node_inputLinksIdOSTyped = exports.reorganize_node_outputLinksIdOSTyped = exports.NodeDisplayed = exports.convert_tags = exports.convert_links = exports.convert_nodes = exports.convert_data = exports.complete_sankey_data = exports.synchronizeNodesandLinksIdOSTyped = exports.AdjustSankeyZone = exports.updateLayoutOSTyped = exports.DefaultNode = exports.DefaultLink = exports.DefaultLinkStyle = exports.AssignLinkValueToCorrectVar = exports.LinkColor = exports.DragLegendGElementOSTyped = exports.ReturnOutOfBoundElement = exports.drag_node_text = exports.DragElements = exports.OpposingDragElements = exports.AssignNodeValueToCorrectVar = exports.IsAllNodeAttrSameValue = exports.IsNodeDisplayingValueLocal = exports.SimpleGNodeClick = exports.SvgDragMiddleMouseMove = exports.SvgDragMiddleMouseStart = exports.RemoveAnimate = exports.DeselectVisualyNodes = exports.LinkVisibleOnSvg = exports.NodeVisibleOnsSvg = exports.GetSankeyMinWidthAndHeight = exports.DrawGrid = exports.DrawArrows = exports.LinkStrokeOSTyped = exports.NodeColor = exports.IsLinkDiplayingValueLocal = exports.IsAllLinkAttrSameValue = exports.ReturnValueNode = exports.ReturnValueLink = void 0;
const OpensankeyUtils = __importStar(require("open-sankey/dist/configmenus/SankeyUtils"));
const OpenSankeyDrawFunc = __importStar(require("open-sankey/dist/draw/SankeyDrawFunction"));
const OpenSankeyDrawEventFunc = __importStar(require("open-sankey/dist/draw/SankeyDrawEventFunction"));
// import * as OpensankeyDragLinksFunc from 'open-sankey/dist/lib/SankeyDragLinks'
const OpensankeyDragNodeFunc = __importStar(require("open-sankey/dist/draw/SankeyDragNodes"));
const OpensankeyConvert = __importStar(require("open-sankey/dist/configmenus/SankeyConvert"));
const OpenSankeyLayout = __importStar(require("open-sankey/dist/draw/SankeyDrawLayout"));
const SankeyDrawLegend_1 = require("open-sankey/dist/draw/SankeyDrawLegend");
exports.ReturnValueLink = OpensankeyUtils.ReturnValueLink;
exports.ReturnValueNode = OpensankeyUtils.ReturnValueNode;
exports.IsAllLinkAttrSameValue = OpensankeyUtils.IsAllLinkAttrSameValue;
exports.IsLinkDiplayingValueLocal = OpensankeyUtils.IsLinkDiplayingValueLocal;
exports.NodeColor = OpensankeyUtils.NodeColor;
exports.LinkStrokeOSTyped = OpenSankeyDrawFunc.LinkStroke;
exports.DrawArrows = OpenSankeyDrawFunc.DrawArrows;
exports.DrawGrid = OpenSankeyDrawFunc.DrawGrid;
exports.GetSankeyMinWidthAndHeight = OpenSankeyDrawFunc.GetSankeyMinWidthAndHeight;
exports.NodeVisibleOnsSvg = OpenSankeyDrawFunc.NodeVisibleOnsSvg;
exports.LinkVisibleOnSvg = OpenSankeyDrawFunc.LinkVisibleOnSvg;
exports.DeselectVisualyNodes = OpenSankeyDrawFunc.DeselectVisualyNodes;
exports.RemoveAnimate = OpenSankeyDrawFunc.RemoveAnimate;
exports.SvgDragMiddleMouseStart = OpenSankeyDrawEventFunc.SvgDragMiddleMouseStart;
exports.SvgDragMiddleMouseMove = OpenSankeyDrawEventFunc.SvgDragMiddleMouseMove;
exports.SimpleGNodeClick = OpenSankeyDrawEventFunc.SimpleGNodeClick;
exports.IsNodeDisplayingValueLocal = OpensankeyUtils.IsNodeDisplayingValueLocal;
exports.IsAllNodeAttrSameValue = OpensankeyUtils.IsAllNodeAttrSameValue;
exports.AssignNodeValueToCorrectVar = OpensankeyUtils.AssignNodeValueToCorrectVar;
exports.OpposingDragElements = OpensankeyDragNodeFunc.OpposingDragElements;
exports.DragElements = OpensankeyDragNodeFunc.DragElements;
exports.drag_node_text = OpensankeyDragNodeFunc.drag_node_text;
exports.ReturnOutOfBoundElement = OpensankeyDragNodeFunc.ReturnOutOfBoundElement;
exports.DragLegendGElementOSTyped = SankeyDrawLegend_1.DragLegendGElement;
exports.LinkColor = OpensankeyUtils.LinkColor;
exports.AssignLinkValueToCorrectVar = OpensankeyUtils.AssignLinkValueToCorrectVar;
exports.DefaultLinkStyle = OpensankeyUtils.DefaultLinkStyle;
exports.DefaultLink = OpensankeyUtils.DefaultLink;
exports.DefaultNode = OpensankeyUtils.DefaultNode;
exports.updateLayoutOSTyped = OpenSankeyLayout.updateLayout;
exports.AdjustSankeyZone = OpensankeyUtils.AdjustSankeyZone;
exports.synchronizeNodesandLinksIdOSTyped = OpenSankeyLayout.synchronizeNodesandLinksId;
exports.complete_sankey_data = OpensankeyConvert.complete_sankey_data;
exports.convert_data = OpensankeyConvert.convert_data;
exports.convert_nodes = OpensankeyConvert.convert_nodes;
exports.convert_links = OpensankeyConvert.convert_links;
exports.convert_tags = OpensankeyConvert.convert_tags;
exports.NodeDisplayed = OpensankeyUtils.NodeDisplayed;
exports.reorganize_node_outputLinksIdOSTyped = OpenSankeyLayout.reorganize_node_outputLinksId;
exports.reorganize_node_inputLinksIdOSTyped = OpenSankeyLayout.reorganize_node_inputLinksId;
exports.actualizeDrawAreaFrame = OpenSankeyDrawEventFunc.actualizeDrawAreaFrame;
